t = require('views/internal/teacup-with-helpers')('member_inline')

module.exports = ->
  t.mustacheBlock 'avatarHash', ->
    t.img '.inline-member-av', { src: t.mustacheVar('__avatarDomain') + '/' + t.mustacheVar('avatarHash') + '/30.png', alt: t.mustacheVar('fullName') + " (" + t.mustacheVar('username') + ")", title: t.mustacheVar('fullName') + " (" + t.mustacheVar('username') + ")" }
  t.span '.u-font-weight-bold', ->
    t.text t.mustacheVar('fullName')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_inline.coffee